<div class="header-container">
    <div class="header-primary-container">
        <div class="container-menu-responsive navbar navbar-expand-lg">
            <button class="nav-responsive govco-bars" type="button" role="button" data-bs-toggle="collapse"
                data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false"
                aria-label="Menú de navegación, Se abrirá menú con más opciones" (click)="clickMenuResponsive($event)">
            </button>
            <div class="collapse navbar-collapse" id="navbarSupportedContent">
                <app-sidebar [verUrlRepository]="true"></app-sidebar>
            </div>
        </div>
        <div class="header-title-icon">
            <div class="header-icon">
                <a href="{{urls.home}}" target="_blank">
                    <img src="{{urls.images}}logo.svg" height="60" width="180" alt="Logo Gov.co">
                </a>
            </div>
            <div class="d-flex align-items-center header-title">
                <h1 class="mb-0">
                    {{ nombrePortal }} <br />
                    <span>{{ subNombrePortal }}</span>
                </h1>
            </div>
        </div>
        <!-- CandyBox -->
        <div class="dropdown-candy-box">
            <button #candyBox class="nav-link dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false"
                aria-label="Aplicaciones y servicios GOV.CO" aria-describedby="tooltip-candy-box"></button>
            <div class="tooltip-text-container" role="tooltip">
                <div class="dropdown-arrow"></div>
                <span class="tooltip-text" id="tooltip-candy-box" lang="es">
                    Acceda a Carpeta Ciudadana Digital y demás servicios relacionados con el Portal Único del Estado
                    Colombiano.
                </span>
            </div>
            <div id="menu-candy-box" class="dropdown-menu dropdown-menu-candy-box" aria-labelledby="dropdown-title-id"
                role="region" tabindex="-1">
                <div class="dropdown-arrow"></div>
                <span class="dropdown-title" id="dropdown-title-id">
                    Aplicaciones y servicios GOV.CO
                </span>
                <ul>
                    <li>
                        <a class="dropdown-item" href="{{urls.home}}" target="_blank">
                            <div class="dropdown-item-icon icon-govco"></div>
                            <span>Portal GOV.CO</span>
                        </a>
                    </li>
                    <li>
                        <a class="dropdown-item" href="{{urls.carpetaciudadana}}" target="_blank">
                            <div class="dropdown-item-icon icon-folder-user"></div>
                            <span>Carpeta Ciudadana</span>
                        </a>
                    </li>
                    <li>
                        <a class="dropdown-item" href="{{urls.tramites}}" target="_blank">
                            <div class="dropdown-item-icon icon-ciiu"></div>
                            <span>Consulta CIIU</span>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
    <div class="header-secundary-container">
        <!-- Menu de versiones -->
        <div class="versions-container width-versions-container">
            <button class="nav-link dropdown-toggle item-versions" id="versions-menu" data-bs-toggle="dropdown"
                aria-expanded="false" aria-label="Versiones del CDN">
                <span>
                    <span class="cdn-gov-co">BDC_GOV.CO </span>
                    V.4
                </span>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                    class="bi bi-chevron-down" viewBox="0 0 16 16">
                    <path fill-rule="evenodd"
                        d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z" />
                </svg>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                    class="bi bi-chevron-up" viewBox="0 0 16 16">
                    <path fill-rule="evenodd"
                        d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708l6-6z" />
                </svg>
            </button>
            <div id="versions" class="dropdown-menu dropdown-menu-versions width-versions-container"
                aria-labelledby="versions-menu">
                <ul>
                    <li *ngFor="let version of versions">
                        <a class="dropdown-item  item-versions" [href]="version.url" target="_blank">
                            <span>
                                <span>BDC_GOV.CO {{ version.version }} (No Vigente)</span>
                            </span>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
        <!-- Buscador -->
        <div class="search-container">
            <app-search></app-search>
        </div>
        <!-- Enlace Repositorio -->
        <app-link-repository [urlRepository]="urlRepository"></app-link-repository>
    </div>
</div>